/**
 * Backup Dashboard Styles
 * Carbon Design System compliant styling for backup management interface
 */
.backupDashboard {
  padding: var(--cds-spacing-05);
  background-color: var(--cds-background);
  min-height: 100vh;
}

.metricTile {
  text-align: center;
  padding: var(--cds-spacing-05);
  height: 100%;
}

.metricValue {
  font-size: 2rem;
  font-weight: 600;
  color: var(--cds-text-primary);
  margin-bottom: var(--cds-spacing-02);
}

.metricLabel {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--cds-text-secondary);
  margin-bottom: var(--cds-spacing-02);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.metricSubtext {
  font-size: 0.75rem;
  color: var(--cds-text-helper);
}

@media (max-width: 672px) {
  .backupDashboard {
    padding: var(--cds-spacing-04);
  }
  .metricValue {
    font-size: 1.5rem;
  }
  .metricLabel {
    font-size: 0.75rem;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvc2t5Z2dlL3NpZ21hMDgvZnJvbnRlbmQvc3JjL3BhZ2VzL2FkbWluIiwic291cmNlcyI6WyJCYWNrdXBEYXNoYm9hcmQubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUFBQTtBQUFBO0FBQUE7QUFLQTtFQUNFO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUlGO0VBQ0U7SUFDRTs7RUFHRjtJQUNFOztFQUdGO0lBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEJhY2t1cCBEYXNoYm9hcmQgU3R5bGVzXG4gKiBDYXJib24gRGVzaWduIFN5c3RlbSBjb21wbGlhbnQgc3R5bGluZyBmb3IgYmFja3VwIG1hbmFnZW1lbnQgaW50ZXJmYWNlXG4gKi9cblxuLmJhY2t1cERhc2hib2FyZCB7XG4gIHBhZGRpbmc6IHZhcigtLWNkcy1zcGFjaW5nLTA1KTtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tY2RzLWJhY2tncm91bmQpO1xuICBtaW4taGVpZ2h0OiAxMDB2aDtcbn1cblxuLm1ldHJpY1RpbGUge1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIHBhZGRpbmc6IHZhcigtLWNkcy1zcGFjaW5nLTA1KTtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuXG4ubWV0cmljVmFsdWUge1xuICBmb250LXNpemU6IDJyZW07XG4gIGZvbnQtd2VpZ2h0OiA2MDA7XG4gIGNvbG9yOiB2YXIoLS1jZHMtdGV4dC1wcmltYXJ5KTtcbiAgbWFyZ2luLWJvdHRvbTogdmFyKC0tY2RzLXNwYWNpbmctMDIpO1xufVxuXG4ubWV0cmljTGFiZWwge1xuICBmb250LXNpemU6IDAuODc1cmVtO1xuICBmb250LXdlaWdodDogNTAwO1xuICBjb2xvcjogdmFyKC0tY2RzLXRleHQtc2Vjb25kYXJ5KTtcbiAgbWFyZ2luLWJvdHRvbTogdmFyKC0tY2RzLXNwYWNpbmctMDIpO1xuICB0ZXh0LXRyYW5zZm9ybTogdXBwZXJjYXNlO1xuICBsZXR0ZXItc3BhY2luZzogMC4wNWVtO1xufVxuXG4ubWV0cmljU3VidGV4dCB7XG4gIGZvbnQtc2l6ZTogMC43NXJlbTtcbiAgY29sb3I6IHZhcigtLWNkcy10ZXh0LWhlbHBlcik7XG59XG5cbi8vIFJlc3BvbnNpdmUgYWRqdXN0bWVudHNcbkBtZWRpYSAobWF4LXdpZHRoOiA2NzJweCkge1xuICAuYmFja3VwRGFzaGJvYXJkIHtcbiAgICBwYWRkaW5nOiB2YXIoLS1jZHMtc3BhY2luZy0wNCk7XG4gIH1cblxuICAubWV0cmljVmFsdWUge1xuICAgIGZvbnQtc2l6ZTogMS41cmVtO1xuICB9XG5cbiAgLm1ldHJpY0xhYmVsIHtcbiAgICBmb250LXNpemU6IDAuNzVyZW07XG4gIH1cbn1cbiJdfQ== */